/**
 * GSTR9New FetchReconcile Constants
 */

// Action types
export const FETCH_RECORDS_REQUEST = 'GSTR9New/FetchReconcile/FETCH_RECORDS_REQUEST';
export const FETCH_RECORDS_SUCCESS = 'GSTR9New/FetchReconcile/FETCH_RECORDS_SUCCESS';
export const FETCH_RECORDS_FAILURE = 'GSTR9New/FetchReconcile/FETCH_RECORDS_FAILURE';

export const RECONCILE_RECORDS_REQUEST = 'GSTR9New/FetchReconcile/RECONCILE_RECORDS_REQUEST';
export const RECONCILE_RECORDS_SUCCESS = 'GSTR9New/FetchReconcile/RECONCILE_RECORDS_SUCCESS';
export const RECONCILE_RECORDS_FAILURE = 'GSTR9New/FetchReconcile/RECONCILE_RECORDS_FAILURE';

export const GET_FETCH_HISTORY_REQUEST = 'GSTR9New/FetchReconcile/GET_FETCH_HISTORY_REQUEST';
export const GET_FETCH_HISTORY_SUCCESS = 'GSTR9New/FetchReconcile/GET_FETCH_HISTORY_SUCCESS';
export const GET_FETCH_HISTORY_FAILURE = 'GSTR9New/FetchReconcile/GET_FETCH_HISTORY_FAILURE';

export const GET_RECONCILE_DATA_HISTORY_REQUEST = 'GSTR9New/FetchReconcile/GET_RECONCILE_DATA_HISTORY_REQUEST';
export const GET_RECONCILE_DATA_HISTORY_SUCCESS = 'GSTR9New/FetchReconcile/GET_RECONCILE_DATA_HISTORY_SUCCESS';
export const GET_RECONCILE_DATA_HISTORY_FAILURE = 'GSTR9New/FetchReconcile/GET_RECONCILE_DATA_HISTORY_FAILURE';

export const SET_SELECTED_RETURN_PERIOD = 'GSTR9New/FetchReconcile/SET_SELECTED_RETURN_PERIOD';
export const SET_SELECTED_GSTIN = 'GSTR9New/FetchReconcile/SET_SELECTED_GSTIN';
export const SET_FETCH_PROGRESS = 'GSTR9New/FetchReconcile/SET_FETCH_PROGRESS';
export const SET_RECONCILE_PROGRESS = 'GSTR9New/FetchReconcile/SET_RECONCILE_PROGRESS';

// Pagination constants
export const SET_PAGINATION_INFO = 'GSTR9New/FetchReconcile/SET_PAGINATION_INFO';
export const SET_CURRENT_PAGE = 'GSTR9New/FetchReconcile/SET_CURRENT_PAGE';
export const SET_PAGE_SIZE = 'GSTR9New/FetchReconcile/SET_PAGE_SIZE';

// Separate pagination constants for fetch and reconcile
export const SET_FETCH_PAGINATION_INFO = 'GSTR9New/FetchReconcile/SET_FETCH_PAGINATION_INFO';
export const SET_RECONCILE_PAGINATION_INFO = 'GSTR9New/FetchReconcile/SET_RECONCILE_PAGINATION_INFO';

// Separate page size constants for fetch and reconcile
export const SET_FETCH_PAGE_SIZE = 'GSTR9New/FetchReconcile/SET_FETCH_PAGE_SIZE';
export const SET_RECONCILE_PAGE_SIZE = 'GSTR9New/FetchReconcile/SET_RECONCILE_PAGE_SIZE';

// Clear data constants
export const CLEAR_FETCH_HISTORY = 'GSTR9New/FetchReconcile/CLEAR_FETCH_HISTORY';
export const CLEAR_RECONCILE_HISTORY = 'GSTR9New/FetchReconcile/CLEAR_RECONCILE_HISTORY';
export const CLEAR_ALL_DATA = 'GSTR9New/FetchReconcile/CLEAR_ALL_DATA';


export const fetchHeaders = [
  {
    value: "Fetch",
    id: "1",
  },
  {
    value: "Reconciliation",
    id: "2",
  },
];